import { fromJS } from 'immutable';
import { GET_RULES, SET_RULES } from './constants';

export const getRules = () => ({
  type: GET_RULES,
});

/** The rulebook's text sections and its photographed pages, both in book order. */
export const setRules = (sections, pages) => ({
  type: SET_RULES,
  payload: fromJS({ sections, pages }),
});
